import { render, staticRenderFns } from "./PendenteComponent.vue?vue&type=template&id=6bd5a6f6&scoped=true"
import script from "./PendenteComponent.vue?vue&type=script&lang=js"
export * from "./PendenteComponent.vue?vue&type=script&lang=js"
import style0 from "./PendenteComponent.vue?vue&type=style&index=0&id=6bd5a6f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd5a6f6",
  null
  
)

export default component.exports